export default __webpack_public_path__ + "static/media/9.2c82928b.mp3";